<script>
import axios from 'axios'
import Logo from '@/components/Logo.vue'
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card/index.js'
import { Input } from '@/components/ui/input/index.js'
import { Button } from '@/components/ui/button/index.js'
import { Label } from '@/components/ui/label/index.js'
import { toast } from 'vue-sonner'

export default {
  components: { Logo, Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle, Input, Button, Label },
  data () {
    return {
      loading: false,
      errors: null,
      data: {
        email: typeof this.$route.query.email === 'string' ? this.$route.query.email : '',
        password: '',
        password_confirmation: ''
      }
    }
  },
  methods: {
    async resetPassword () {
      if (this.loading) {
        return
      }

      this.errors = null
      this.loading = true

      try {
        await axios.get('/sanctum/csrf-cookie')
        const response = await axios.post('/reset-password', { ...this.data, token: this.$route.params.token })
        await this.$router.push({ name: 'Login' })
        toast.success(response.data.message || this.$t('password_reset.reset_success'))
      } catch (error) {
        this.errors = error.response?.data ?? { message: this.$t('password_reset.error') }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<template>
  <div class="min-h-screen flex flex-col justify-center items-center gap-6 p-4">
    <Logo />
    <form class="w-full max-w-sm" @submit.prevent="resetPassword">
      <Card>
        <CardHeader>
          <CardTitle class="text-2xl">
            {{ $t('password_reset.reset_title') }}
          </CardTitle>
          <CardDescription>{{ $t('password_reset.reset_description') }}</CardDescription>
        </CardHeader>
        <CardContent class="grid gap-4">
          <div class="grid gap-2">
            <Label for="email">{{ $t('login.email') }}</Label>
            <Input id="email" v-model="data.email" type="email" name="email" autocomplete="email" required autofocus />
          </div>
          <div class="grid gap-2">
            <Label for="password">{{ $t('login.password') }}</Label>
            <Input id="password" v-model="data.password" type="password" name="password" autocomplete="new-password" required />
          </div>
          <div class="grid gap-2">
            <Label for="password_confirmation">{{ $t('password_reset.confirm_password') }}</Label>
            <Input id="password_confirmation" v-model="data.password_confirmation" type="password" name="password_confirmation" autocomplete="new-password" required />
          </div>
          <div v-if="errors" role="alert" class="grid gap-1 text-sm text-destructive">
            <template v-if="errors.errors">
              <p v-for="(messages, field) in errors.errors" :key="field">
                {{ messages.join(' ') }}
              </p>
            </template>
            <p v-else>
              {{ errors.message }}
            </p>
          </div>
        </CardContent>
        <CardFooter class="flex flex-col gap-4">
          <Button block :loading="loading" type="submit">
            {{ $t('password_reset.reset_button') }}
            <template #loading>
              {{ $t('password_reset.processing') }}
            </template>
          </Button>
          <router-link :to="{ name: 'Login' }" class="text-sm text-muted-foreground underline hover:text-foreground">
            {{ $t('password_reset.back_to_login') }}
          </router-link>
        </CardFooter>
      </Card>
    </form>
  </div>
</template>
